import type CreateProCheckoutResponse from '../types/CreateProCheckoutResponse';
import type ProResponse from '../types/ProResponse';
import type Subscription from '../types/Subscription';
import buildCheckoutSessionId from './buildCheckoutSessionId';
import completeCheckoutSessionSubscription from './completeCheckoutSessionSubscription';
import createSubscription from './createSubscription';
import isThreeDSecureResponse from './isThreeDSecureResponse';
import type { ThreeDSecureAnalyticsInfo } from './runThreeDSecureFlow';
import runThreeDSecureFlow from './runThreeDSecureFlow';

type PerformInitialSubscriptionPurchaseArgs = {
  analyticsInfo: ThreeDSecureAnalyticsInfo;
  body: Subscription;
  container: HTMLElement;
  onThreeDSEnd: () => void;
  onThreeDSStart: () => void;
};

export default async function performInitialSubscriptionPurchase({
  analyticsInfo,
  body,
  container,
  onThreeDSEnd,
  onThreeDSStart
}: PerformInitialSubscriptionPurchaseArgs): Promise<ProResponse> {
  const checkoutSessionId = buildCheckoutSessionId();

  const response = (await createSubscription({ ...body, checkout_session_id: checkoutSessionId })) as CreateProCheckoutResponse;

  if (!isThreeDSecureResponse(response)) {
    return response;
  }

  return runThreeDSecureFlow({
    actionTokenId: response.three_d_secure_action_token_id,
    analyticsInfo,
    checkoutSessionId,
    completeCheckoutSession: threeDSecureActionResultTokenId =>
      completeCheckoutSessionSubscription({ checkoutSessionId, threeDSecureActionResultTokenId }),
    container,
    onThreeDSEnd,
    onThreeDSStart
  });
}
